import { Component } from '@angular/core';

@Component({
  selector: 'app-advantages',
  templateUrl: './advantages.component.html',
  styleUrls: ['./advantages.component.scss']
})
export class AdvantagesComponent {
  advantages = [
    {
      title: 'innovative_solutions',
      description: 'we_are_always_implementing'
    },
    {
      title: 'flexible_adaptation',
      description: 'our_team_quickly_adapts_the_service'
    },
    {
      title: 'integration_with_popular_platforms',
      description: 'integration_with_platforms_for_convenient_management'
    },
    {
      title: 'mobility_and_convenience',
      description: 'our_crm_system_is_available_on_all_devices'
    },
    {
      title: 'process_automation',
      description: 'automate_sales'
    },
    {
      title: 'support',
      description: 'we_provide_fast_support'
    }
  ];
}
